/**
 * @generated SignedSource<<3495e906af697383be8ce85715897c4a>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type hooksUseNotificationReadStatusArticle$data = {
  readonly entityId: string;
  readonly " $fragmentType": "hooksUseNotificationReadStatusArticle";
};
export type hooksUseNotificationReadStatusArticle$key = {
  readonly " $data"?: hooksUseNotificationReadStatusArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"hooksUseNotificationReadStatusArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "hooksUseNotificationReadStatusArticle"
};

(node as any).hash = "ae3e3a7860bf4b714657649413505a7b";

export default node;
